/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One saved version of a config, as listed in its change history
 * @export
 * @interface ConfigChangeResponse
 */
export interface ConfigChangeResponse {
    /**
     * 
     * @type {Date}
     * @memberof ConfigChangeResponse
     */
    createdAt: Date;
    /**
     * The earlier version this one was restored from, if it was created by a restore
     * @type {string}
     * @memberof ConfigChangeResponse
     */
    restoredFromId: string | null;
    /**
     * Back office user id that saved this version; null if not known
     * @type {string}
     * @memberof ConfigChangeResponse
     */
    changedBy: string | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ConfigChangeResponse
     */
    id: string;
}

/**
 * Check if a given object implements the ConfigChangeResponse interface.
 */
export function instanceOfConfigChangeResponse(value: object): value is ConfigChangeResponse {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('restoredFromId' in value) || value['restoredFromId'] === undefined) return false;
    if (!('changedBy' in value) || value['changedBy'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ConfigChangeResponseFromJSON(json: any): ConfigChangeResponse {
    return ConfigChangeResponseFromJSONTyped(json, false);
}

export function ConfigChangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigChangeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'restoredFromId': json['restoredFromId'],
        'changedBy': json['changedBy'],
        'id': json['id'],
    };
}

export function ConfigChangeResponseToJSON(value?: ConfigChangeResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'restoredFromId': value['restoredFromId'],
        'changedBy': value['changedBy'],
        'id': value['id'],
    };
}

